import { createFileRoute } from '@tanstack/react-router';
import { OrganizationProfilePage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/profile')({
  component: OrganizationProfilePage,
});
